import { GetterTree } from "vuex/types";
import { RootState } from "@/store/types";
import { ApiEditorState } from "./types";

const getters: GetterTree<ApiEditorState, RootState> = {};

export default getters;
